/**
 * Pre-Order Feature — Feelgrounds
 * - Detects pre-order variants (inventory_policy: continue + inventory_quantity <= 0)
 * - Updates button text, info box, hidden property on variant change
 * - Sets cart attribute 'pre_order: true' for Shopify Flow order tagging
 */

(function () {
  'use strict';

  function isPreorderVariant(variant, sectionId) {
    if (!variant) return false;
    const productForm = document.querySelector(`.product-form[data-section="${sectionId}"]`);
    if (!productForm || productForm.dataset.preorderProduct !== 'true') return false;
    return variant.inventory_policy === 'continue' && variant.inventory_quantity <= 0;
  }

  function updatePreorderUI(variant, sectionId) {
    const preorder = isPreorderVariant(variant, sectionId);
    const productForm = document.querySelector(`.product-form[data-section="${sectionId}"]`);
    const infoBox = document.getElementById(`preorder-info-${sectionId}`);
    const preorderProp = document.getElementById(`preorder-prop-${sectionId}`);
    const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

    if (!productForm) return;

    // Update template attribute so toggleAddButton picks up the right text
    if (preorder) {
      productForm.setAttribute('template', 'pre-order');
    } else {
      const original = productForm.dataset.originalTemplate || '';
      productForm.setAttribute('template', original);
    }

    // Show / hide info box
    if (infoBox) {
      if (preorder) {
        infoBox.removeAttribute('hidden');
      } else {
        infoBox.setAttribute('hidden', '');
      }
    }

    // Enable / disable hidden line item property
    if (preorderProp) {
      if (preorder) {
        preorderProp.removeAttribute('disabled');
      } else {
        preorderProp.setAttribute('disabled', 'disabled');
      }
    }

    // Update button text (only if button is not disabled/sold-out)
    if (variant && variant.available) {
      submitButtons.forEach(function (btn) {
        if (btn.hasAttribute('disabled')) return;
        const textEl = btn.querySelector('.single-add-to-cart-button--text');
        if (!textEl) return;
        if (preorder) {
          var poInfoBox = document.querySelector('.preorder-info[data-t-button]');
          var poBtn = (poInfoBox && poInfoBox.dataset.tButton) ||
                      (window.theme && window.theme.variantStrings && window.theme.variantStrings.preOrder) ||
                      'Pre-Order now';
          textEl.textContent = poBtn;
        } else {
          textEl.textContent = (window.theme && window.theme.variantStrings && window.theme.variantStrings.addToCart) || 'In den Warenkorb';
        }
      });
    }
  }

  function updateCartAttribute() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasPreorder = cart.items.some(function (item) {
          return item.properties && item.properties['_preorder'] === 'true';
        });
        var currentAttr = cart.attributes && cart.attributes['pre_order'];
        var targetAttr = hasPreorder ? 'true' : '';

        if (currentAttr === targetAttr) return; // No change needed

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { pre_order: targetAttr } })
        });
      });
  }

  // Store original template on page load + initialize pre-order state immediately
  document.querySelectorAll('.product-form').forEach(function (form) {
    form.dataset.originalTemplate = form.getAttribute('template') || '';

    // If this product has no delivery date set, it's not a pre-order product — hide box immediately
    var sectionId = form.dataset.section;
    var infoBox = document.getElementById('preorder-info-' + sectionId);
    if (infoBox && form.dataset.preorderProduct !== 'true') {
      infoBox.setAttribute('hidden', '');
      form.setAttribute('template', form.dataset.originalTemplate.replace('pre-order', '').trim());
      var preorderProp = document.getElementById('preorder-prop-' + sectionId);
      if (preorderProp) preorderProp.setAttribute('disabled', 'disabled');
    }
  });

  // Listen for variant changes
  document.documentElement.addEventListener('product:variant-change', function (e) {
    var variant = e.detail && e.detail.variant;
    var sectionId = e.detail && e.detail.sectionId;
    if (!sectionId) return;
    updatePreorderUI(variant, sectionId);
  });

  // Update cart attribute when item is added
  document.documentElement.addEventListener('cart:item-added', function () {
    updateCartAttribute();
  });

  // Update cart attribute on cart refresh (item removed etc.)
  document.documentElement.addEventListener('cart:refresh', function () {
    updateCartAttribute();
  });

  // Run on page load in case cart already has preorder items
  updateCartAttribute();

})();
